import PropTypes from "prop-types";
import React from "react";
import ImmutablePropTypes from "react-immutable-proptypes";
import { connect } from "react-redux";

import ToolbarGroup from "../../components/toolbar/ToolbarGroup";
import ToolbarIconButton from "../../components/toolbar/ToolbarIconButton";
import ToolbarView from "../../components/toolbar/ToolbarView";
import {
  GLOBAL_FILTER_PANEL,
  HARVARD_SETTINGS_PANEL,
  LOCAL_FILTER_PANEL,
  SCROLL_TO_DATE_PANEL,
  SEARCH_PANEL
} from "../../constants/identifiers";
import interfaceIdentifiers from "../../constants/interfaceIdentifiers";
import { appStateOperations, appStateSelectors } from "../../modules/appState";
import batchOperations from "../../modules/batchOperations";
import { definitionSelectors } from "../../modules/definition";
import { filterSelectors } from "../../modules/filters";
import { mindmapSelectors } from "../../modules/mindmaps";
import { uiStateSelectors } from "../../modules/uiState";
import { mergeDispatchToProps } from "../../utils/codeSplit";

const Toolbar = props => {
  return (
    <ToolbarView domId={props.domId} isEditMode={false}>
      <ToolbarGroup position="center">
        {/* <ToolbarIconButton
          id="toolbarTimelineButton"
          icon="inspectorTime"
          active={props.leftPanelMode === null}
          color="iconMono"
          onClick={props.onTimelineClick}
        /> */}
        <ToolbarIconButton
          id="toolbarSearchButton"
          icon="toolbarSearch"
          active={props.leftPanelMode === SEARCH_PANEL}
          color="iconMono"
          onClick={props.onSearchClick}
          pulse={props.pulsateIconId === interfaceIdentifiers.SEARCH}
        />
        {!props.disableFiltering ? (
          <ToolbarIconButton
            id="toolbarFilterButton"
            icon={props.localFilterIsActive ? "toolbarFilterActive" : "toolbarFilter"}
            active={props.leftPanelMode === GLOBAL_FILTER_PANEL || props.leftPanelMode === LOCAL_FILTER_PANEL}
            color="iconMono"
            onClick={props.onFilterClick}
            pulse={props.pulsateIconId === interfaceIdentifiers.FILTER}
          />
        ) : null}
        <ToolbarIconButton
          id="sidebarScrollToDate"
          icon={"sidebarScrollToDate"}
          active={props.leftPanelMode === SCROLL_TO_DATE_PANEL}
          color="iconMono"
          onClick={props.onScrollToDateClick}
        />
        <ToolbarIconButton
          icon="sidebarSettings"
          tooltip="Settings"
          active={props.leftPanelMode === HARVARD_SETTINGS_PANEL}
          pulse={props.pulsateIconId === interfaceIdentifiers.SETTINGS}
          onClick={props.onSettingsClick}
        />
      </ToolbarGroup>
    </ToolbarView>
  );
};

Toolbar.propTypes = {
  domId: PropTypes.string,
  includeNarrative: PropTypes.bool.isRequired,
  mobileViewType: PropTypes.string.isRequired,
  leftPanelMode: PropTypes.string,
  localFilterIsActive: PropTypes.bool,
  selectedItemIds: ImmutablePropTypes.listOf(PropTypes.string),
  pulsateIconId: PropTypes.string,
  disableFiltering: PropTypes.bool.isRequired,
  // Actions
  onTimelineClick: PropTypes.func.isRequired,
  onSearchClick: PropTypes.func.isRequired,
  onFilterClick: PropTypes.func.isRequired,
  onSettingsClick: PropTypes.func.isRequired,
  onScrollToDateClick: PropTypes.func.isRequired
};

const mapStateToProps = state => {
  const mobileViewType = appStateSelectors.getMobilePortraitViewType(state.present);
  return {
    includeNarrative: definitionSelectors.isNarrativeAllowed(state.present),
    mobileViewType: appStateSelectors.getMobilePortraitViewType(state.present),
    leftPanelMode: appStateSelectors.getLeftPanelMode(state.present),
    localFilterIsActive: filterSelectors.isFilterWithIdActive(state.present, mobileViewType),
    existingMindmaps: mindmapSelectors.getMindmapList(state.present),
    pulsateIconId: uiStateSelectors.getPulsateIconId(state.present),
    selectedItemIds: uiStateSelectors.getSelectedItems(state.present),
    disableFiltering: appStateSelectors.getDisableFiltering(state.present)
  };
};

const readonlyActions = {
  onTimelineClick: () => {
    return batchOperations.hideLeftPanelAndClearSelection();
  },
  onSearchClick: () => {
    return appStateOperations.setLeftPanelMode(SEARCH_PANEL);
  },
  onFilterClick: () => {
    return appStateOperations.setLeftPanelMode(LOCAL_FILTER_PANEL);
  },
  onSettingsClick: () => {
    return appStateOperations.setLeftPanelMode(HARVARD_SETTINGS_PANEL);
  },
  onScrollToDateClick: () => {
    return appStateOperations.toggleScrollToDatePanel();
  }
};

const mapDispatchToProps = dispatch => mergeDispatchToProps(readonlyActions, null, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Toolbar);
